import { LegalDocument } from './LegalDocument';

export default function Terms() {
  return <LegalDocument doc="terms" />;
}
